export const EPayPaymentType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "CARI",
   2: "CREDITCARD",
   3: "CREDITCARD_NON_3D",
   4: "SOFORT",
   5: "IDEAL",
};
